/****************************************************
 *
 *                  THROW ERROR
 *
 ***************************************************/

export const throwError = (data: ResponsePayload) => {
  if (data.error.status === 1) throw new Error(data.error.message);
};
